import type {
  SendMissingContractInformationPushNotificationMutation,
  SendMissingContractInformationPushNotificationMutationVariables
} from './__generated__/SendMissingContractInformationPushNotificationMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  SendMissingContractInformationPushNotificationMutation,
  SendMissingContractInformationPushNotificationMutationVariables
> = gql`
  mutation SendMissingContractInformationPushNotificationMutation(
    $input: SendMissingContractInformationPushNotificationInput!
  ) {
    sendMissingContractInformationPushNotification(input: $input) {
      status
    }
  }
`

export function sendMissingContractInformationPushNotificationMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      SendMissingContractInformationPushNotificationMutation,
      SendMissingContractInformationPushNotificationMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
